import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.25 21.75A.75.75 0 0 1 10 21h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M10.25 2.25A.75.75 0 0 1 11 1.5h2A.75.75 0 0 1 13 3h-2a.75.75 0 0 1-.75-.75M12 5.5a5.25 5.25 0 0 0-5.25 5.25v5.5a.75.75 0 0 1-.126.416L5.401 18.5H18.6l-1.223-1.834a.75.75 0 0 1-.126-.416v-5.5c0-2.9-2.35-5.25-5.25-5.25m-6.75 5.25a6.75 6.75 0 0 1 13.5 0v5.273l1.356 2.034A1.25 1.25 0 0 1 19.066 20H4.934a1.25 1.25 0 0 1-1.04-1.943l1.356-2.034z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }